// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
        suggestionMobileStyle: 'style2',
        suggestionStyle2MainContainerSelector: '#searchBarHeader',
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

// #178096
BCSfFilter.prototype.openSuggestionEvent = function(searchBoxId, ev) {
    var self = this;
    // Prevent double tap on iOS
    if (self.isiOS()) {
        jQ('.' + this.class.searchSuggestionItem + ' a')
            .on('touchstart', function() {
                isScrolling = false;
            })
            .on('touchmove', function(e) {
                isScrolling = true;
            })
            .on('touchend', function(e) {
                if (!isScrolling) {
                    window.location = jQ(this).attr('href');
                }
            });
    }
    /* On mobile, prevent body from scrolling if it is full suggestion style */
    var $body = jQ('body');
    if(self.checkIsFullWidthSuggestionMobile(searchBoxId) && !$body.hasClass(self.getClass('searchSuggestionMobileOpen'))){
        $body.addClass(self.getClass('searchSuggestionMobileOpen'));
    }
    jQ('.bc-sf-search-suggestion-wrapper').addClass('is-active');
};

// Close Suggestion Event
BCSfFilter.prototype.closeSuggestionEvent = function(searchBoxId) {
    // Test Mode - Turn on when need check elements of Auto Complete
    // Prevent closing Auto complete when opening Inspect Element
    if (this.getSettingValue('search.suggestionMode') == 'test' || this.checkIsFullWidthSuggestionMobile(searchBoxId)) {
        // if (!jQ('ul.ui-autocomplete').is(":visible")) {
        jQ('.' + this.class.searchSuggestion).show();
        // }
    } else {
        jQ('.' + this.class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').siblings().hide();
    }
    // Always hide loading and show content
    // this.hideSuggestionLoading();
    jQ('.bc-sf-search-suggestion-wrapper').removeClass('is-active');
};
// End #178096